import { render, staticRenderFns } from "./TemplateFolderFieldtype.vue?vue&type=template&id=67bddc7c&"
import script from "./TemplateFolderFieldtype.vue?vue&type=script&lang=js&"
export * from "./TemplateFolderFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports